import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import store from '@/store';
import { TreeItem, TreeType } from '@/components/Layers/modal/types';
import CCheckbox from '@/components/shared/CCheckbox.vue';
import CDropdown from '@/components/CDropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalImportLayersTreeItemExternal',
  props: {
    treeItem: null,
    treeItemIndex: null
  },
  setup(__props: any) {

const props = __props as {
    treeItem: TreeItem;
    treeItemIndex?: number;
};



const getElementTypes = (elementType: TreeType) => {
    switch (elementType) {
        case TreeType.FROM_FILE_TEXT_ELEMENT:
        case TreeType.FROM_FILE_CALENDAR_ELEMENT:
        case TreeType.FROM_FILE_MAP_ELEMENT:
        case TreeType.FROM_FILE_MOON_PHASE_ELEMENT:
        case TreeType.FROM_FILE_STAR_MAP_ELEMENT:
            return [
                {
                    value: TreeType.FROM_FILE_TEXT_ELEMENT,
                    text: 'Text'
                },
                {
                    value: TreeType.FROM_FILE_CALENDAR_ELEMENT,
                    text: 'Calendar'
                },
                {
                    value: TreeType.FROM_FILE_MAP_ELEMENT,
                    text: 'Map'
                },
                {
                    value: TreeType.FROM_FILE_MOON_PHASE_ELEMENT,
                    text: 'Moon Phase'
                },
                {
                    value: TreeType.FROM_FILE_STAR_MAP_ELEMENT,
                    text: 'Star Map'
                }
            ];
        case TreeType.FROM_FILE_IMAGE_ELEMENT:
        case TreeType.FROM_FILE_IMAGE_PLACEHOLDER_ELEMENT: {
            return [
                {
                    value: TreeType.FROM_FILE_IMAGE_PLACEHOLDER_ELEMENT,
                    text: 'Image Placeholder'
                },
                {
                    value: TreeType.FROM_FILE_IMAGE_ELEMENT,
                    text: 'Dynamic Image'
                }
            ];
        }
        case TreeType.FROM_FILE_VECTOR_ELEMENT:
        case TreeType.FROM_FILE_VECTOR_PLACEHOLDER_ELEMENT: {
            return [
                {
                    value: TreeType.FROM_FILE_VECTOR_PLACEHOLDER_ELEMENT,
                    text: 'Vector Placeholder'
                },
                {
                    value: TreeType.FROM_FILE_VECTOR_ELEMENT,
                    text: 'Dynamic Vector'
                }
            ];
        }
        default:
            return [
                {
                    value: TreeType.FROM_FILE_TEXT_ELEMENT,
                    text: 'Text'
                },
                {
                    value: TreeType.FROM_FILE_IMAGE_PLACEHOLDER_ELEMENT,
                    text: 'Image Placeholder'
                },
                {
                    value: TreeType.FROM_FILE_IMAGE_ELEMENT,
                    text: 'Dynamic Image'
                },
                {
                    value: TreeType.FROM_FILE_VECTOR_PLACEHOLDER_ELEMENT,
                    text: 'Vector Placeholder'
                },
                {
                    value: TreeType.FROM_FILE_VECTOR_ELEMENT,
                    text: 'Dynamic Vector'
                },
                {
                    value: TreeType.FROM_FILE_CALENDAR_ELEMENT,
                    text: 'Calendar'
                },
                {
                    value: TreeType.FROM_FILE_MAP_ELEMENT,
                    text: 'Map'
                },
                {
                    value: TreeType.FROM_FILE_MOON_PHASE_ELEMENT,
                    text: 'Moon Phase'
                },
                {
                    value: TreeType.FROM_FILE_STAR_MAP_ELEMENT,
                    text: 'Star Map'
                }
            ];
    }
};

const hasChildren = computed(() => props.treeItem.children?.length);

const selected = computed({
    get() {
        if (props.treeItem.children && props.treeItem.children.length)
            return store.state.storeLayersModal!.selectedTreeItems.length === props.treeItem.children.length;

        return store.state.storeLayersModal!.selectedTreeItems.some((item) => {
            return item.id === props.treeItem.id;
        });
    },
    set(value: boolean) {
        const handleTreeItem = (treeItem: TreeItem) => {
            if (value) {
                store.dispatch('storeLayersModal/addSelectedTreeItem', treeItem);
            } else {
                store.dispatch('storeLayersModal/removeSelectedTreeItem', treeItem);
            }
        };

        const methods: Record<string, (treeItem: TreeItem) => void> = {
            [TreeType.FROM_FILE_TEXT_ELEMENT]: handleTreeItem,
            [TreeType.FROM_FILE_IMAGE_PLACEHOLDER_ELEMENT]: handleTreeItem,
            [TreeType.FROM_FILE_IMAGE_ELEMENT]: handleTreeItem,
            [TreeType.FROM_FILE_VECTOR_PLACEHOLDER_ELEMENT]: handleTreeItem,
            [TreeType.FROM_FILE_VECTOR_ELEMENT]: handleTreeItem,
            [TreeType.FROM_FILE_CALENDAR_ELEMENT]: handleTreeItem,
            [TreeType.FROM_FILE_MAP_ELEMENT]: handleTreeItem,
            [TreeType.FROM_FILE_MOON_PHASE_ELEMENT]: handleTreeItem,
            [TreeType.FROM_FILE_STAR_MAP_ELEMENT]: handleTreeItem,
            default: (treeItem) => {
                if (!hasChildren.value) methods[treeItem.type](treeItem);
                treeItem.children?.forEach((item: TreeItem) => {
                    methods[item.type](item);
                });
            }
        };
        const method = methods[props.treeItem.type] || methods['default'];

        method(props.treeItem);
    }
});

const handleTreeItem = () => {
    selected.value = !selected.value;
};

const onTreeItemTypeChange = (treeItem: TreeItem, type: TreeType) => {
    treeItem.type = type;
};

return { __sfc: true,props, getElementTypes, hasChildren, selected, handleTreeItem, onTreeItemTypeChange, CCheckbox, CDropdown }
}

})